import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import { useNavigate } from "react-router-dom";
import Profileimg from "../assets/user.png";
import Locationicon from "../assets/placeholder 1.png";
import Messageicon from "../assets/envelope 1.png";
import { fetchData } from '../redux/apiSlice';
import { useSelector, useDispatch, } from 'react-redux';
import { FaMoneyCheckAlt } from "react-icons/fa";
import { toastify } from "../redux/controller";



export default function Profile() {
  const Navigate = useNavigate();

  const dispatch = useDispatch()
  const handleEditprofile = () => {
    Navigate("/editprofile");
  };
  const [userdata, setuserdata] = useState({});
  const usertoken = useSelector((state) => state.userdata.usertoken)
  const userinfo = useSelector((state) => state.userdata.userdata)

  const [loading, setLoading] = useState(false);

  const hasSetUserdata = useRef(false);

  useEffect(() => {
    if (userinfo && !hasSetUserdata.current) {
      setuserdata(userinfo);
      hasSetUserdata.current = true;
    }
  }, [userinfo]);

  const [loadingReferral, setLoadingReferral] = useState(false);

  const handleReferLandowner = async () => {
    setLoadingReferral(true);
    try {
      const body = {
        apiurl: "/auth/user/generate-affiliate-code",
        headers: { "x-access-token": usertoken }
      };
      const response = await dispatch(fetchData(body));
      if (response && response.payload && response.payload.status === 200) {
        const affiliateLink = response.payload.data.affiliateLink;
        
        try {
          await navigator.clipboard.writeText(affiliateLink);
          toastify({ message: "Link copied now you can share link" });
        } catch (clipboardErr) {
          const textArea = document.createElement("textarea");
          textArea.value = affiliateLink;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
          toastify({ message: "Link copied now you can share link" });
        }
      } else {
        const errMsg = (response && response.payload && response.payload.message) || "Failed to generate referral link";
        toastify({ message: errMsg });
      }
    } catch (error) {
      console.error("Error generating affiliate link:", error);
      toastify({ message: "An error occurred. Please try again." });
    } finally {
      setLoadingReferral(false);
    }
  };

  const [referredUsers, setReferredUsers] = useState([]);
  const [loadingReferred, setLoadingReferred] = useState(false);

  const fetchReferredUsers = async () => {
    if (!usertoken) return;
    setLoadingReferred(true);
    try {
      const body = {
        apiurl: "/auth/user/affiliated-users",
        headers: { "x-access-token": usertoken },
      };
      const response = await dispatch(fetchData(body));
      if (response && response.payload && response.payload.status === 200) {
        setReferredUsers(response.payload.data || []);
      }
    } catch (error) {
      console.error("Error fetching referred landowners:", error);
    } finally {
      setLoadingReferred(false);
    }
  };

  useEffect(() => {
    if (usertoken) {
      fetchReferredUsers();
    }
  }, [usertoken]);

  const convertdate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "N/A";
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };



  var stripeEmail = '';
  if (userdata.stripeemail != null && userdata.stripeemail.length > 0) {
    stripeEmail = userdata.stripeemail;
  } else if (userdata.stripeaccountdata != null) {
    if (userdata.stripeaccountdata.email != null) {
      stripeEmail = userdata.stripeaccountdata.email;
    }
  }

  return (
    <div className="profile-main">
      <div className="profile-name">
        <div className="profile-img">
          {userdata.image ? <img src={process.env.REACT_APP_BASEURL + "/" + userdata.image} alt="Profileimg" /> : <img src={Profileimg} alt="Profileimg" />}
        </div>

        <div className="profile-contentmain">
          <h1>{userdata.firstname} {userdata.lastname}</h1>
          <div className="profile-content">
            <div className="profile-content-icon">
              <img src={Locationicon} alt="Locationicon" />
              <p>{userdata.livein} </p>
            </div>
            <div className="message-content-icon">
              <img src={Messageicon} alt="Messageicon" />
              <p>{userdata.email} </p>
            </div>
          </div>
        </div>

        <button className="profile-refer-btn" onClick={handleReferLandowner} disabled={loadingReferral}>
          {loadingReferral ? <span className="spinner"></span> : "Refer New Landowner"}
        </button>
      </div>
      <div className="profile-details">
        <div className="profile-top">
          <h1>Profile Details</h1>
          <button onClick={handleEditprofile}>Edit Profile</button>
        </div>

        <div className="profile-details-main">
          <div className="profile-details-content">
            <div className="first-part">
              <p>First Name:</p>
            </div>
            <div className="second-part">
              <p>{userdata.firstname}</p>
            </div>
          </div>

          <div className="profile-details-content">
            <div className="first-part">
              <p>Last Name:</p>
            </div>
            <div className="second-part">
              <p>{userdata.lastname}</p>
            </div>
          </div>

          <div className="profile-details-content">
            <div className="first-part">
              <p>Email Address:</p>
            </div>
            <div className="second-part">
              <p>{userdata.email}</p>
            </div>
          </div>

          <div className="profile-details-content">
            <div className="first-part">
              <p className="first-part-span">Email for receiving stripe connect payment</p>
              <span>(booking fees, refund security fees, etc)</span>
            </div>
            <div className="second-part">
              <p>{stripeEmail}</p>
            </div>
          </div>

          <div className="profile-details-content">
            <div className="first-part">
              <p>Phone Number:</p>
            </div>
            <div className="second-part">
              <p>{userdata.phonenumber}</p>
            </div>
          </div>

          <div className="profile-details-content">
            <div className="first-part">
              <p>I live in:</p>
            </div>
            <div className="second-part">
              <p>{userdata.livein}</p>
            </div>
          </div>

          <div className="profile-details-content">
            <div className="first-part">
              <p>Website:</p>
            </div>
            <div className="second-part">
              <p>{userdata.website}</p>
            </div>
          </div>

          <div className="profile-details-content">
            <div className="first-part">
              <p>About Me:</p>
            </div>
            <div className="second-part">
              <p>{userdata.aboutme}</p>
            </div>
          </div>

        </div>

      </div>

      <div className="profile-details">
        <div className="profile-top">
          <h1>Referred Landowners</h1>
        </div>

        <div className="profile-details-main">
          {loadingReferred ? (
            <div className="referred-loading">
              <span className="spinner"></span> Loading referred landowners...
            </div>
          ) : referredUsers.length === 0 ? (
            <div className="referred-empty">
              No landowners have been referred yet.
            </div>
          ) : (
            <div className="referred-table-container">
              <table className="referred-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email Address</th>
                    <th>User Signup Date</th>
                    <th>Affiliate Commission</th>
                    <th>Total Earnings</th>
                  </tr>
                </thead>
                <tbody>
                  {referredUsers.map((user) => (
                    <tr key={user._id}>
                      <td>{user.firstname} {user.lastname}</td>
                      <td>{user.email}</td>
                      <td>{convertdate(user.createdAt)}</td>
                      <td>{user.affiliateCommissionPercentage != null ? `${user.affiliateCommissionPercentage}%` : "5%"}</td>
                      <td>{user.totalEarnings != null ? `$${parseFloat(user.totalEarnings).toFixed(2)}` : "$0.00"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* <div className="earnings-main">
        <div className="earnings-top">
          <h1>Earnings</h1>
          <button className="request-payment-btn"
            disabled={pendingEarnings < 200}
            onClick={handleRequestPayment}
          > {loading ? <span className="spinner"></span> : 'Request Payment'}</button>
        </div>
        <div className="earnings-dashboard">
          <div className="earnings-card pending">
            <div className="earnings-icon">
              <FaMoneyCheckAlt />
              <h3>Total Earnings:</h3>
            </div>
            <div>
              <p>${totalEarnings.toFixed(2)}</p>
            </div>
          </div>

          <div className="earnings-card paid">
            <div className="earnings-icon">
              <FaMoneyCheckAlt />
              <h3>Paid Earnings:</h3>
            </div>
            <div>
              <p>${paidEarnings.toFixed(2)}</p>
            </div>
          </div>


          <div className="earnings-card paid">
            <div className="earnings-icon">
              <FaMoneyCheckAlt />
              <h3>Pending Earnings:</h3>
            </div>
            <div>
              <p>${pendingEarnings.toFixed(2)}</p>
            </div>
          </div>



        </div>
        <div className="earning-info-text">
          You may request a payment once your pending earnings reach the minimum payout threshold of $200.
        </div>
      </div> */}

      <div className="bottom-sized-box" ></div>
    </div>
  );
}
